export default __webpack_public_path__ + "static/media/web_screen_engage_ko.fae0e332.png";